module["exports"] = [  
  "##",
  "#"
];



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/id_ID/address/building_number.js
// module id = 1341
// module chunks = 0